import StarRating from '@/frontend/components/qecomps/StarRating'
import AbbreviateDate from '@/frontend/components/qecomps/AbbreviateDate'
import Image from 'next/image'
import { useEffect, useState } from 'react'
import Bold from '@/frontend/components/qecomps/Bold'
import Copy from '@/frontend/components/qecomps/Copy'
import Router from 'next/router'
import SiteConfig from '@/common/SiteConfig'
import Component, { PageEl } from '@/frontend/components/qecomps/Component'
import TextEndAbbreviation from '@/frontend/components/qecomps/TextEndAbbreviation'
import JVideo from './JVideo'
import { SSRGlobal } from '../qecomps/Context'
import Img from '../qecomps/Img'



export default p => Component(p, Page);
const Page: PageEl = (props: {} & { [key: string]: any }, refresh, getProps, onLoad, onConnected, dies, isFront, z) => {

    // getProps(async ()=>{
    //     state
    // })

    useEffect(() => {
        global.vplay = () => {
            setPhase("video")
            setPhase("video"); setTimeout(() => (document.getElementById("hpv_" + props.index) as HTMLVideoElement).play(), 200);
        }
    }, [])

    var [phase, setPhase] = useState(props.items.length == 1 && props.item.video?"video":null)
    var videl = null;
    var iframeimg = global.cdn("/files/youtube1.svg")

    const send = async (obj, api) => {
        return await API["journal/" + api](obj)
    }


    if (phase == "iframe") {
        iframeimg = global.cdn("/files/video3.svg")
    }
    else {
        if (props.item.iframe?.includes("aparat")) {
            iframeimg = global.cdn("/files/aparat.svg")
        }
    }



    var titlecomp = <f-csb style={{
        position: "absolute", backgroundColor: "#000000", borderRadius: 2,
        top: 0, height: 30, width: "100%", direction: "rtl",//direction: z.lang.dir as any,
    }}>

        <f-c class={z.styles.hoverfade} style={{
            fontSize: 12, color: "white", direction: z.lang.dir as any,
            backgroundColor: props.item.isadmin && z.lang.code == "fa" ? "#61005A" :
                (props.item.isowner && z.lang.code == "fa" ? "#0044C1" : "green"), padding: "0 5px",
            minHeight: 20, flexDirection: "row-reverse", borderTopLeftRadius: 3, borderBottomLeftRadius: 3
        }}
            onClick={() => { if (z.lang.code == "fa") props.ondateclick?.() }}
        >
            {props.item.video ? <>

                {props.item.iframe ? <><Img src={iframeimg} className={z.styles.opaquex}
                    style={{
                        width: 16, height: 16, display: "inline-block",
                        verticalAlign: "middle", margin: "0 5px"
                    }}
                    on={() => {
                        if (phase == "iframe") {
                            setPhase("video")
                        }
                        else {
                            setPhase("iframe")
                        }
                    }} /></> : null}

                {phase == "video" ? <><Img className={z.styles.opaquex} src={global.cdn("/files/fullscreenw.svg")}
                    style={{
                        width: 16, height: 16,
                        display: "inline-block", verticalAlign: "middle", margin: "0 5px"
                    }}
                    on={() => {
                        videl = document.getElementById("hpv_" + props.index) as HTMLVideoElement
                        videl.requestFullscreen()
                        videl.muted = false
                        var muteimg = document.getElementById("hpmute_" + props.item.jid) as HTMLImageElement
                        muteimg.src = global.cdn("/files/unmute.svg")
                    }} />
                </> : null}

            </> : null}
            <f-12 style={{ padding: "0 10px", direction: z.lang.dir as any }}><Bold>{
                AbbreviateDate(props.item.date)
            }</Bold></f-12 >
        </f-c>

        <f-c>
            {props["loaded"] && z.user.uid && props.item.uid == z.user.uid || z.user.role?.includes("admin")
                || z.user.role?.includes("journal") ? <f-cc>
                <span style={{
                    fontSize: 11, color: "white", padding: "2px 10px", direction: z.lang.dir as any, backgroundColor: "maroon",
                    borderRadius: 3, margin: "0 5px",
                }} className={z.styles.hoverfade} onClick={async () => {
                    if (await confirmer(z.lang.delete, z.lang.delconf)) {
                        let code = (await send({ jid: props.item.jid }, "delete")).code
                        if (code == 0) {
                            Router.push(z.root)
                        }
                        else if (code == -3) {
                            alerter(z.lang.itemdeltranserr)
                        }
                        else {
                            alerter(z.lang.somethingwrong)
                        }
                    }
                }}>
                    {z.lang.delete}
                </span>
            </f-cc> : null}

            <sp-4 />

            {props.item.pinned ? <Img src={global.cdn("/files/pinwx.svg")}
                style={{ margin: "0 6px", width: 18, height: 18, }}
                className={z.styles.hoverfade} /> : null}

            <f-cc onClick={(e) => { e.stopPropagation() }}>
                {(props.item.uid != z.user.uid) && props.item.private ? <>
                    <sp-4 />
                    <Img src={global.cdn("/files/unlockw.svg")} style={{ margin: "0 8px", width: 15, height: 15, }}
                        className={z.styles.hoverfade} on={() => {
                            alerter(z.lang.privatejrnl)
                        }} />
                </> : null}

                {z.user.role?.includes("journal") || z.user.role?.includes("admin") ? <>
                    <sp-2 />
                    <f-cc class={z.styles.hoverfade} onClick={() => { props.onzclick?.() }}>
                        <f-11 style={{ color: "white" }}>{(props.item.z || 0).toLocaleString(z.lang.region)}</f-11>
                        <Img src={global.cdn("/files/z.svg")} style={{ width: 15, height: 13, margin: "0 5px 2px 5px" }} />
                    </f-cc>
                    <sp-2 />
                </> : null}


                <f-cc class={z.styles.hoverfade}>
                    <f-11 style={{ color: "white" }}>{(props.item.commentscount || 0).toLocaleString(z.lang.region)}</f-11>
                    <Img src={global.cdn("/files/cmntwhite2.svg")} style={{ width: 20, height: 20, margin: "0 5px 2px 5px" }} />
                </f-cc>

                <sp-3 />
                <f-cc class={z.styles.hoverfade} onClick={() => { props.onviewclick?.() }}>
                    <f-11 style={{ color: "white" }}>{(props.item.views || 0).toLocaleString(z.lang.region)}</f-11>
                    <Img src={global.cdn("/files/eyeview.svg")} style={{ width: 16, height: 16, margin: "0 5px 2px 5px" }} />
                </f-cc>



                <sp-4 />
                <Img src={global.cdn("/files/savew.svg")} style={{
                    margin: "0 8px", width: 15, height: 15,
                    opacity: props.item.saved ? 1 : 0.6
                }}
                    className={z.styles.hover} on={async () => {
                        await send({ jid: props.item.jid, save: !props.item.saved }, "save")
                        props.item.saved = !props.item.saved;
                        refresh()
                    }} />
                <sp-4 />
                <Img src={global.cdn("/files/sharew.svg")} style={{ margin: "0 8px", width: 15, height: 15, }}
                    className={z.styles.hoverfade} on={async () => {


                        var u = new URL(window.location.href);
                        var domain = u.protocol + '//' + u.host + z.root + "/" + props.item.key;

                        Copy(domain)
                        success(z.lang.copied)

                        // Copy(SiteConfig.address + "/" + z.lang.code + "/?jid=" + props.item.jid)
                        // alerter(z.lang.copied)
                    }} />
                <sp-4 />
            </f-cc>


        </f-c>



    </f-csb>

    var votercomp = <f-c style={{
        position: "absolute", backgroundColor: "#000000bb", borderRadius: 0,
        bottom: 0, height: 30, width: "100%"
    }}
        onMouseMove={(e) => {
            if (phase != null) {
                e.stopPropagation();
            }
        }}>
        <sp-3 />
        <Img className={z.styles.opaquex} src={global.cdn("/files/fullscreenw.svg")}
            style={{
                width: 20, height: 20, opacity: 0.5,
                display: "inline-block", verticalAlign: "middle", margin: "0 5px"
            }}
            on={() => {
                videl = document.getElementById("hpv_" + props.index) as HTMLVideoElement
                if (!videl)
                    return
                videl.requestFullscreen()
                videl.muted = false
                var muteimg = document.getElementById("hpmute_" + props.item.jid) as HTMLImageElement
                muteimg.src = global.cdn("/files/unmute.svg")
            }} />

        <sp-4 />
        <span style={{ fontSize: 12, color: "white", opacity: 0.85 }} onClick={() => {
            props.onplzvote?.()
        }}><sp-3 />{z.lang.plzvote}</span><sp-2 />
        <StarRating id={"hpst_" + props.index} myvote={props.item.myvote} stars={props.item.stars}
            width={23} height={17} showrank fontSize={12} style={{ opacity: 0.85 }}
            voterscount={props.item.voterscount} on={async (star) => {

                let json = await API['journal/vote']({
                    vote: star,
                    jid: props.item.jid
                })

                if (json.code == 0) {
                    props.item.stars = json.newstars;
                    props.item.voterscount = json.newvoterscount;
                    props.item.myvote = star
                    refresh()
                }
            }} />


        {props.item.video ? <f-ce id={props.subtid + "_voice"} class={z.styles.vmt}
            style={{
                bottom: 0, height: 30,
                margin: "0 3px",
                left: z.lang.dir == "rtl" ? 0 : null,
                right: z.lang.dir == "ltr" ? 0 : null,
                // backgroundColor:"#ffffff55"
            }}
            onMouseDown={() => {
                var video = document.getElementById("hpv_" + props.index) as HTMLVideoElement
                if (!video)
                    return
                var muteimg = document.getElementById("hpmute_" + props.item.jid) as HTMLImageElement
                if (video.muted) {
                    muteimg.src = global.cdn("/files/unmute.svg")
                    video.muted = false

                }
                else {
                    muteimg.src = global.cdn("/files/mute.svg")
                    video.muted = true
                }
            }}>
            <Img className={z.styles.opaque} id={"hpmute_" + props.item.jid} src={global.cdn("/files/unmute.svg")}
                style={{ width: 20, height: 20, cursor: "pointer" }} />
        </f-ce> : null}
    </f-c>


    return <div
        style={{
            flex:1, backgroundColor: "#000000", borderRadius: 0,
            direction: z.lang.dir as any,
        }}
    >




        {!phase ? <div className={z.styles.expmedia} style={{
            position: "relative", borderRadius: 0, overflow: 'hidden', width: "100%", zIndex: 20,

        }}>

            <img src={global.cdn(props.item.poster)}
                alt={"this is the main image of " + props.item.title1}
                style={{
                    position: "absolute",
                    height: "100%",
                    width: "100%",
                    left: 0, top: 0, right: 0, bottom: 0,
                    objectFit: "contain",
                    color: "transparent",
                    backgroundColor: "black",
                    // backgroundImage:"url('https://cdn.qepal.com/qepal/bgs/bg8.png')",
                    padding: "15px -15px",

                }} fetchPriority={props.index == 0 ? "high" : "low"} loading={props.index == 0 ? "eager" : "lazy"} />


            {props.item.video ? <Img src={global.cdn("/files/playbtn.svg")} className={z.styles.hover}
                style={{
                    position: "absolute", width: 40, height: 40, opacity: 0.9,
                    top: "calc(50% - 20px)", left: "calc(50% - 20px)", cursor: "pointer"
                }}
                onMouseDown={(e) => { setPhase("video"); setTimeout(() => (document.getElementById("hpv_" + props.index) as HTMLVideoElement).play(), 200); e.stopPropagation(); }}
                onTouchStart={(e) => {
                    setPhase("video")
                    setPhase("video"); setTimeout(() => (document.getElementById("hpv_" + props.index) as HTMLVideoElement).play(), 200);
                    e.stopPropagation();
                }}
            /> : null}
            {titlecomp}
            {votercomp}
            <br-x />
        </div> : null}



        {phase == "iframe" ? <div className={z.styles.expmedia} style={{
            position: "relative",
            //  height: '70vw',
            padding: window.innerWidth > 800 ? "20px 0 0 0" : null,
            minHeight: window.innerWidth > 800 ? null : (75000 / 1024) + "vw",
            width: "calc(100% - 4px)"
        }}>
            <iframe
                style={{
                    height: 'calc(70vw - 30px)', maxHeight: 'calc(min(330px , 60vh) - 30px)',
                    width: "100%", borderRadius: 5,
                }}
                src={props.item.iframe} frameBorder="0"
                allowFullScreen={true}></iframe>
            <div style={{ height: 30, backgroundColor: "#000", width: "100%", marginTop: -7, borderRadius: 5 }}></div>
            {titlecomp}
            {votercomp}
        </div> : null}



        {phase == "video" ? <JVideo show={true} item={props.item} index={props.index} interval={props.interval}>
            {titlecomp}
            {votercomp}
        </JVideo> : null}

    </div>

}